import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import Footer from "../../../Components/Footer/footer";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import { toast } from "react-toastify";

const OrderDetails = () => {
  const { orderId, farmerPartnerAssigned } = useParams();
  const [deliveryPartnerId, setDeliveryPartnerId] = useState(null);

  const [order, setOrder] = useState([]);
  const [hasButton, setHasButton] = useState(false);

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    orderStatus: "",
    sortByDate: "",
  });
  const [deliveryPartners, setDeliveryPartners] = useState(null);
  const navigate = useNavigate();

  // ✅ Fetch Order Details
  const getOrderDetails = async () => {
    try {
      setLoading(true);

      const res = await performRequest(
        "GET",
        `/pmg/farmer-partner/epg-user-order-details/${orderId}/${farmerPartnerAssigned}`
      );

      setOrder(res?.data);
    } catch (err) {
      Toast("error", "Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Update Order Status
  const updateStatus = async (status) => {
    console.log(status, "status");
    try {
      await performRequest(
        "PATCH",
        `/pmg/order/update-order-status/${orderId}?farmerPartnerAssigned=${farmerPartnerAssigned}&orderStatus=${status}`,
        {
          status,
        }
      );

      Toast("success", "Status updated");
      getOrderDetails();
    } catch (err) {
      Toast("error", "Failed to update status");
    }
  };

  useEffect(() => {
    getOrderDetails();
  }, []);
  useEffect(() => {
    performRequest(
      "GET",
      `/pmg/delivery-partner/get-all-delivery-partner/${farmerPartnerAssigned}`
    )
      .then((res) => {
        if (res.status === 200) {
          console.log(res, "thisi s response");
          setDeliveryPartners(res?.data?.deliveryPartners);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleConfirmDeliveryPartner = async () => {
    console.log(deliveryPartnerId, "delvoeir parterr id");
    const data = {
      orderId,
      farmerPartnerId: farmerPartnerAssigned,
      deliveryPartnerId,
      assignBy: farmerPartnerAssigned,
    };

    performRequest("POST", `/pmg/delivery-partner/order-assign`, data)
      .then((res) => {
        console.log(res);
        Toast("success", "Order Assign Successfully");
      })
      .catch((error) => {
        console.error(error);
        Toast(
          "error",
          error?.response?.data?.message && "Order already assigned"
        );
      });
  };

  if (loading) return <p className="text-center mt-5">Loading...</p>;
  if (!order) return <p className="text-center mt-5">No Order Found</p>;

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          {/* HEADER */}
          <div className="page-header">
            <h2 className="page-title">Order Details</h2>
          </div>

          <div className="row m-1">
            {(() => {
              const steps = [
                { key: "pending", label: "Placed" },
                { key: "processing", label: "Received" },
                { key: "packaged", label: "Packed" },
                { key: "outForDelivery", label: "On Way" },
                { key: "delivered", label: "Delivered" },
              ];

              const currentIndex = steps.findIndex(
                (s) => s.key === order.orderStatus
              );

              return (
                <div className="row d-md-none ">
                  <div className="card p-3 mb-3">
                    <div
                      className="d-flex flex-column position-relative"
                      style={{ gap: 0 }}
                    >
                      {steps.map((step, index) => {
                        const isCompleted =
                          index < currentIndex ||
                          (order.orderStatus === "delivered" &&
                            index === currentIndex);
                        const isCurrent =
                          index === currentIndex &&
                          order.orderStatus !== "delivered";
                        const isDisabled = index > currentIndex;

                        return (
                          <div
                            key={index}
                            className="d-flex align-items-center position-relative"
                            style={{ minHeight: 60 }}
                          >
                            {/* Vertical line segment — hidden for last item */}
                            {index < steps.length - 1 && (
                              <div
                                style={{
                                  position: "absolute",
                                  left: "19px",
                                  top: "40px",
                                  bottom: "-20px",
                                  width: "2px",
                                  backgroundColor: isCompleted
                                    ? "#28a745"
                                    : "#ccc",
                                  zIndex: 0,
                                }}
                              />
                            )}

                            {/* Circle */}
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{
                                width: 40,
                                height: 40,
                                fontSize: "18px",
                                fontWeight: "600",
                                backgroundColor: isCompleted
                                  ? "#28a745"
                                  : isCurrent
                                  ? "#ffc107"
                                  : "#ccc",
                                color: "#fff",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                border: isCurrent
                                  ? "2px solid #e6a800"
                                  : "none",
                                zIndex: 1,
                              }}
                              onClick={() => {
                                if (!isDisabled && !isCurrent)
                                  updateStatus(step.key);
                              }}
                            >
                              {isCompleted ? "✓" : index + 1}
                            </div>

                            {/* Label + Button */}
                            <div className="ms-3 d-flex align-items-center gap-3">
                              <span
                                style={{
                                  fontSize: "20px",
                                  fontWeight: isCurrent ? "700" : "400",
                                  color: isDisabled ? "#aaa" : "#333",
                                  lineHeight: 1.2,
                                }}
                              >
                                {step.label}
                              </span>

                              {isCurrent && index < steps.length - 1 && (
                                <button
                                  className="btn btn-primary"
                                  style={{
                                    fontSize: "20px",
                                    padding: "2px 10px",
                                  }}
                                  onClick={() =>
                                    updateStatus(steps[index + 1].key)
                                  }
                                >
                                  → {steps[index + 1].label}
                                </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })()}
            {/* data this is good */}

            {(() => {
              const steps = [
                { key: "pending", label: "Placed" },
                { key: "processing", label: "Received" },
                { key: "packaged", label: "Packed" },
                { key: "outForDelivery", label: "On Way" },
                { key: "delivered", label: "Delivered" },
              ];

              const currentIndex = steps.findIndex(
                (s) => s.key === order.orderStatus
              );
              const hasButton =
                currentIndex < steps.length - 1 &&
                order.orderStatus !== "delivered";

              return (
                <div className="row d-none d-md-block">
                  <div className="card p-3 mb-3">
                    <div className="d-flex align-items-center justify-content-between position-relative">
                      {/* Connecting line */}
                      <div
                        style={{
                          position: "absolute",
                          top: hasButton ? "20px" : "190px",
                          left: "5%",
                          right: "5%",
                          height: "2px",
                          backgroundColor: "#ccc",
                          zIndex: 0,
                        }}
                      />

                      {steps.map((step, index) => {
                        const isCompleted =
                          index < currentIndex ||
                          (order.orderStatus === "delivered" &&
                            index === currentIndex);
                        const isCurrent =
                          index === currentIndex &&
                          order.orderStatus !== "delivered";
                        const isDisabled = index > currentIndex;

                        return (
                          <div
                            key={index}
                            className="d-flex flex-column align-items-center"
                            style={{ zIndex: 1, flex: 1 }}
                          >
                            {/* Circle */}
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                width: 40,
                                height: 40,
                                fontSize: "28px",
                                fontWeight: "600",
                                backgroundColor: isCompleted
                                  ? "#28a745"
                                  : isCurrent
                                  ? "#ffc107"
                                  : "#ccc",
                                color: "#fff",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                border: isCurrent
                                  ? "2px solid #e6a800"
                                  : "none",
                              }}
                              onClick={() => {
                                if (!isDisabled && !isCurrent)
                                  updateStatus(step.key);
                              }}
                            >
                              {isCompleted ? "✓" : index + 1}
                            </div>

                            {/* Label */}
                            <small
                              className="mt-1 text-center"
                              style={{
                                fontSize: "20px",
                                fontWeight: isCurrent ? "700" : "400",
                                color: isDisabled ? "#aaa" : "#333",
                                lineHeight: 1.2,
                              }}
                            >
                              {step.label}
                            </small>

                            {/* Button */}
                            {isCurrent && index < steps.length - 1 ? (
                              <button
                                className="btn btn-primary mt-1"
                                style={{ fontSize: "20px", padding: "2px 6px" }}
                                onClick={() =>
                                  updateStatus(steps[index + 1].key)
                                }
                              >
                                → {steps[index + 1].label}
                              </button>
                            ) : (
                              <button
                                className="btn btn-white mt-1 "
                                style={{
                                  fontSize: "20px",
                                  padding: "2px 6px",
                                  visibility: "hidden",
                                }}
                                // onClick={() =>
                                //   updateStatus(steps[index + 1].key)
                                // }
                              >
                                {/* → {steps[index + 1].label} */}
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })()}

            <div className="row">
              <div className="col-md-3 col-sm-12 pb-2">
                <div className="card p-2">
                  <div
                    id="faq-1"
                    className="accordion"
                    role="tablist"
                    aria-multiselectable="true"
                  >
                    <div>
                      <div className="accordion-header m-0" role="tab">
                        <button
                          className="accordion-button fs-3 d-md-none p-0"
                          data-bs-toggle="collapse"
                          data-bs-target="#faq-1-1"
                        >
                          <h3 className="m-1">Assign Delivery Partner</h3>
                        </button>
                      </div>

                      <div
                        id="faq-1-1"
                        className="accordion-collapse collapse d-md-none"
                        role="tabpanel"
                        data-bs-parent="#faq-1"
                      >
                        <div className="accordion-body pt-0">
                          <div className="row">
                            <div className="col-12">
                              <DynamicFilterSelect
                                name="assignDeliveryPartner"
                                id="assignDeliveryPartner"
                                style={{ fontSize: "20px" }}
                                onChange={(e) => {
                                  console.log(e.target.value, "val");
                                  setDeliveryPartnerId(e.target.value);
                                }}
                              >
                                <option value="assingPartner">
                                  Select Delivery Partner
                                </option>
                                {deliveryPartners?.map((el) => {
                                  console.log();
                                  return (
                                    <option value={el?.id}>
                                      {el?.deliveryPartnerName}
                                    </option>
                                  );
                                })}
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-12">
                                  <button
                                    onClick={() =>
                                      handleConfirmDeliveryPartner()
                                    }
                                    className="btn btn-success w-100 fs-2"
                                  >
                                    Confirm Delivery Partner
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="accordion-body d-none d-md-block">
                        <div className="row">
                          <h3 className="fs-2">Assign Delivery Partner</h3>
                          <div className="col-12 mt-2">
                            <DynamicFilterSelect
                              name="assignDeliveryPartner"
                              id="assignDeliveryPartner"
                              style={{ fontSize: "20px" }}
                              onChange={(e) => {
                                setDeliveryPartnerId(e.target.value);
                              }}
                            >
                              <option value="assingPartner">
                                Select Delivery Partner
                              </option>
                              {deliveryPartners?.map((el) => (
                                <option key={el.id} value={el.id}>
                                  {el.deliveryPartnerName}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-12">
                                <button
                                  onClick={() => handleConfirmDeliveryPartner()}
                                  className="btn btn-success w-100 fs-2"
                                >
                                  Confirm Delivery Partner
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 col-sm-12 pb-2 fs-2">
                {/* ================= TOP CARDS ================= */}
                <div className="row row-deck">
                  {/* Order Info */}
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-header">
                        <h3 className="card-title fs-2 fw-bold">Order Info</h3>
                      </div>
                      <div className="card-body">
                        <p>
                          <strong>Order ID:</strong> {order.orderNumber}
                        </p>
                        <p>
                          <strong>Status:</strong>
                          <span className="badge bg-warning text-white ms-2">
                            {order.orderStatus}
                          </span>
                        </p>
                        <p>
                          <strong>Payment:</strong>
                          <span className="badge bg-success text-white ms-2">
                            {order.paymentStatus}
                          </span>
                        </p>
                        <p>
                          <strong>Method:</strong> {order.paymentMethod}
                        </p>
                        <p>
                          <strong>Date:</strong>{" "}
                          {new Date(order.createdAt).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Pricing */}
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-header">
                        <h3 className="card-title fs-2 fw-bold">Pricing</h3>
                      </div>
                      <div className="card-body">
                        <p>Cart: ₹{order?.totalAmount}</p>
                        <p>Discount: ₹{order?.totalDiscount}</p>
                        <p>Wallet Used: ₹{order?.walletAmountUsed}</p>
                        <p>Packaging: ₹{order?.packagingCharge}</p>
                        <hr />
                        <h4 className="fs-2">Total: ₹{order?.totalAmount}</h4>
                      </div>
                    </div>
                  </div>

                  {/* Delivery */}
                  <div className="col-md-4">
                    <div className="card mb-3">
                      <div className="card-header">
                        <h3 className="card-title fs-2 fw-bold">Delivery</h3>
                      </div>
                      <div className="card-body">
                        <p>
                          <strong>Customer Name:</strong>{" "}
                          {order?.deliveryAddress?.fullName || "N/A"}
                        </p>
                        <p>
                          <strong>Delivery Address :</strong>{" "}
                          {order.deliveryAddress?.addressLine1} |{" "}
                          {order?.deliveryAddress?.addressLine2}
                        </p>
                        <p>
                          <strong>Delivered On:</strong>{" "}
                          {order.deliveryOn
                            ? new Date(
                                Number(order.deliveryOn)
                              ).toLocaleString()
                            : "Not Delivered"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ================= ORDER ITEMS ================= */}
                <div className="card fs-2">
                  <div className="card-header">
                    <h3 className="card-title fs-2 fw-bold">Order Items</h3>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-vcenter table-hover">
                      <thead className="fs-2 fw-bold">
                        <tr className="fs-2 fw-bold">
                          <th style={{ width: "80px" }}>Image</th>
                          <th>Item</th>
                          <th>Type</th>
                          <th className="text-center">Qty</th>
                          <th className="text-end">Price</th>
                          <th className="text-end">Total</th>
                        </tr>
                      </thead>

                      <tbody>
                        {order.epg_order_items?.map((item, i) => {
                          const isRecipe = item.recipeId !== null;

                          return (
                            <tr key={i}>
                              {/* Product Image */}
                              <td>
                                <img
                                  src={
                                    item?.product?.image ||
                                    "https://via.placeholder.com/60"
                                  }
                                  alt="product"
                                  className="rounded border"
                                  style={{
                                    width: "60px",
                                    height: "60px",
                                    objectFit: "cover",
                                  }}
                                />
                              </td>

                              {/* Item Details */}
                              <td>
                                {!isRecipe && (
                                  <>
                                    <div className="fw-bold">
                                      {item?.product?.title || "Product"}
                                    </div>

                                    <small className="text-muted">
                                      Product ID: {item.productId}
                                    </small>
                                  </>
                                )}

                                {isRecipe && (
                                  <>
                                    <div className="fw-bold text-info">
                                      Recipe #{item.recipeId}
                                    </div>

                                    <ul className="mt-2 mb-0 small text-white ">
                                      {item.items?.map((sub, idx) => (
                                        <li key={idx}>
                                          Variant {sub.variant_id} • Qty{" "}
                                          {sub.quantity} • ₹{sub.price}
                                        </li>
                                      ))}
                                    </ul>
                                  </>
                                )}
                              </td>

                              {/* Type Badge */}
                              <td>
                                <span
                                  className={`badge ${
                                    isRecipe
                                      ? "bg-info-lt text-info"
                                      : "bg-green-lt text-green"
                                  }`}
                                >
                                  {isRecipe ? "Recipe" : "Product"}
                                </span>
                              </td>

                              {/* Quantity */}
                              <td className="text-center">
                                <span className="badge bg-secondary text-white">
                                  {item.quantity}
                                </span>
                              </td>

                              {/* Price */}
                              <td className="text-end">
                                ₹{Number(item.priceAtPurchase).toFixed(2)}
                              </td>

                              {/* Total */}
                              <td className="text-end fw-bold">
                                ₹{Number(item.total).toFixed(2)}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* ================= ACTION BUTTONS ================= */}
              </div>
            </div>

            <div className="text-end">
              <button
                className="btn btn-outline-secondary  text-end"
                onClick={() => navigate(-1)}
              >
                ← Back
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OrderDetails;
